import { useState } from "react";
import { Link } from "react-router-dom";
import { MailCheck, Loader2 } from "lucide-react";
import { api, errMsg } from "@/lib/api";
import { Logo, useSettings } from "@/components/common";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

export default function ForgotPassword() {
  const settings = useSettings();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setSent(data.message);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8FAFC] px-5">
      <form onSubmit={submit} className="card-surface w-full max-w-md p-8 fade-up" data-testid="forgot-password-form">
        <div className="mb-6 flex items-center gap-2">
          <Logo settings={settings} className="h-10 w-10" />
          <div className="leading-tight"><div className="font-display font-bold text-[#0F2042]">Passrace</div><div className="text-[10px] font-semibold uppercase tracking-widest text-amber-600">Registro Nazionale MSP Italia</div></div>
        </div>
        <h1 className="font-display text-2xl font-bold text-slate-900">Password dimenticata?</h1>
        {sent ? (
          <div className="mt-6 flex gap-3 rounded-lg border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-900" data-testid="forgot-password-sent">
            <MailCheck className="h-5 w-5 shrink-0" />{sent} Il link è valido 1 ora.
          </div>
        ) : (
          <>
            <p className="mt-2 text-sm text-slate-600">Inserisci l'email del tuo account: ti invieremo un link personale per reimpostare la password.</p>
            <div className="mt-6 space-y-4">
              <Input type="email" required placeholder="nome@esempio.it" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11" data-testid="forgot-password-email-input" />
              <Button type="submit" disabled={busy} className="h-11 w-full bg-[#0F2042] hover:bg-[#1E3A8A]" data-testid="forgot-password-submit-btn">
                {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Invia link"}
              </Button>
            </div>
          </>
        )}
        {error && <div className="mt-4 rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-800" data-testid="forgot-password-error">{error}</div>}
        <Link to="/login" className="mt-6 inline-block text-sm text-slate-500 hover:text-slate-900" data-testid="forgot-password-login-link">Torna all'accesso</Link>
      </form>
    </div>
  );
}
